import apiService from '../apiService';

/**
 * 購買前同意／契約簽署紀錄（合併列表）
 */
export const getPurchaseSigningRecords = async (params = {}) => {
    const url = '/api/admin/purchase-signing-records';
    return apiService.GET(url, params);
};

/**
 * 刪除單筆紀錄（recordKey：flow_{id} 或 consent_{id}）
 * @param {string} recordKey
 */
export const deletePurchaseSigningRecord = async (recordKey) => {
    const encoded = encodeURIComponent(recordKey);
    return apiService.DELETE(`/api/admin/purchase-signing-records/${encoded}`);
};
